<!-- Header Structure -->
<template>
  <div>
    <v-navigation-drawer
      v-if="!horizontal"
      app
      fixed
      v-model="drawer"
      :mini-variant.sync="collapseSidebar"
      mini-variant-width="70"
      :width="250"
      class="Vuely-sidebar"
      :class="{'background-none': true}"
    >
      <!-- App Sidebar -->
      <app-sidebar></app-sidebar>
    </v-navigation-drawer>
    <v-toolbar
      class="Vuely-toolbar header"
      app
      fixed
    >
      <div class="d-custom-flex align-items-center navbar-left">
        <div v-if="!horizontal">
          <v-toolbar-side-icon
            icon
            large
            @click.stop="drawer = !drawer"
            class="v-step-0"
          ></v-toolbar-side-icon>
        </div>
        <div
          class="site-logo-wrap d-custom-flex ml-0 align-items-center"
          v-else
        >
          <router-link
            to="/dashboard"
            class="site-logo-img"
          >
            <img
              src="/static/img/ml-logo.png"
              alt="site logo"
              height="60"
            >
          </router-link>
        </div>
        <!--quick-links></quick-links-->
        <!-- v-text-field
          flat
          solo
          prepend-icon="search"
          :placeholder="'Buscar'"
          class="search-bar m-l-10"
        ></v-text-field-->
        <div class="mobile-search d-none">
          <v-btn
            flat
            icon
            small
            class="mobile-search-btn"
            @click="toggleSearchForm"
          >
            <v-icon class="font-md">search</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="navbar-right">

        <!--v-btn
          icon
          large
          @click="toggleFullScreen"
          class="full-screen ma-0"
        >
          <v-icon color="white">fullscreen</v-icon>
        </v-btn>
        <v-btn
          class="ma-0"
          icon
          large
          @click.stop="chatSidebar = !chatSidebar"
        >
          <v-icon color="white">notifications</v-icon>
        </v-btn-->
        <img
          src="/static/img/logo-login.png"
          class="site logo"
          height="30"
        >
        <span class="white--text">EIRA</span>
        <notifications></notifications>
        <user></user>
      </div>
    </v-toolbar>
    <!-- Chat Searchbar -->
    <!--v-navigation-drawer fixed v-model="chatSidebar" temporary app class="chat-sidebar-wrap">
			<chat-sidebar></chat-sidebar>
		</v-navigation-drawer-->
    <mobile-search-form></mobile-search-form>
  </div>
</template>

<script>
import { getCurrentAppLayout } from 'Helpers/helpers'
import { mapGetters } from 'vuex'
import Sidebar from '../Sidebar/Sidebar.vue'
// import ChatSidebar from "../ChatSidebar/ChatSidebar.vue";
// import LanguageProvider from "./LanguageProvider";
import Notifications from './Notifications'
import User from './User'
// import QuickLinks from './QuickLinks'
import MobileSearchForm from './MobileSearchForm'

export default {
  props: {
    horizontal: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      collapsed: false, // collapse sidebar
      drawer: null, // sidebar drawer default true
      chatSidebar: false, // chat component right sidebar
      sidebarImages: '', // sidebar background images
      enableDefaultSidebar: false
    }
  },
  computed: {
    ...mapGetters([
      'selectedSidebarBgImage',
      'collapseSidebar',
      'activeHeaderFilter'
    ])
  },
  methods: {
    // toggle full screen method
    sidebarPath (link) {
      this.$store.dispatch('setActiveMenuGroup', { pathURL: link })
      this.$router.push(this.getMenuLink(link))
    },
    getMenuLink (link) {
      return `/${getCurrentAppLayout(this.$router)}${link}`
    },
    toggleSearchForm () {
      this.$store.dispatch('toggleSearchForm')
    }
  },
  components: {
    appSidebar: Sidebar,
    // ChatSidebar,
    Notifications,
    // QuickLinks,
    MobileSearchForm,
    User
  }
}

</script>
<style scoped>
.header {
  background: linear-gradient(to right, #fff 20%, #5e4295 59%);
}
.logo {
  vertical-align: middle;
  margin-right: 15px;
}
</style>
